class TradeInProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');

    this.addItemButton = this.querySelector('#add-trade-in-item-button');
    this.addItemButton.addEventListener('click', this.handleClickAddItem.bind(this));
    this.tradeinCartDrawer = document.querySelector('trade-in-drawer');
  }

  async setIsKnownItem(isKnownItem) {
    this.isKnownItem = isKnownItem;
  }

  async handleClickAddItem(evt) {
    evt.preventDefault();

    const tradeinUuid = await getTradeinUuid();

    // add the item the user selected to be added to the tradein
    const formData = new FormData(this.form);
    const addItemToTradeinVars = {
      tradeinUuid,
      parentSku: formData.get('trade-in-search-input')
    };
    if (!this.isKnownItem) {
      addItemToTradeinVars.department = formData.get('department');
      addItemToTradeinVars.category = formData.get('item-category');
    }

    const tradein = await addItemToTradein(addItemToTradeinVars);
    if (!tradein) {
      const messageContainer = document.querySelector('.add-trade-in-message')
      messageContainer.innerText = messageContainer.dataset.message;
      return;
    }
    const tradeinCartIcon = document.querySelector('trade-in-cart-icon-bubble');
    tradeinCartIcon.setCount(tradein?.tradeinItems?.length)
    await this.tradeinCartDrawer.open(tradein);
  }
}

customElements.define('trade-in-product-form', TradeInProductForm);
